/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { EcoLabelCardFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { EcoLabelCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { ecoLabelItemDataMock, ecoLabelItemDataMockEmptyDialog } from '../EcoLabelItem/mockdata';

export const ecoLabelCardDataMock: EcoLabelCardFragmentFragment = {
  ecoLabels: [ecoLabelItemDataMock, ecoLabelItemDataMockEmptyDialog],
};

export function getEcoLabelCardFragmentedData(data?: EcoLabelCardFragmentFragment) {
  return makeFragmentData(data || ecoLabelCardDataMock, EcoLabelCardFragmentFragmentDoc);
}
